var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
import React, { useState, useEffect, createContext } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '../../common/Button';
import useSession from '../../hooks/use-session';
import { authorizedPyInstance as py } from '../../helpers/api';
var SessionTimeoutContext = createContext({});
var minutesToMilliseconds = function minutesToMilliseconds(m) {
  return m * 60 * 1000;
};
var TIMEOUT_BUFFER_LIMIT = minutesToMilliseconds(50);
var TIMEOUT_INACTIVE_LIMIT = minutesToMilliseconds(10);
var SessionTimeoutProvider = function SessionTimeoutProvider(_ref) {
  var children = _ref.children;
  var history = useHistory();
  var location = useLocation();
  var _useSession = useSession(),
    isAuthed = _useSession.isAuthed;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    bufferTimeout = _useState4[0],
    setBufferTimeout = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    inactiveTimeout = _useState6[0],
    setInactiveTimeout = _useState6[1];
  var toggleModal = function toggleModal() {
    return setIsOpen(function (p) {
      return !p;
    });
  };
  var sessionTimeoutStart = function sessionTimeoutStart() {
    setBufferTimeout(setTimeout(function () {
      setIsOpen(true);
      setInactiveTimeout(setTimeout(function () {
        history.push('/session-timeout');
      }, TIMEOUT_INACTIVE_LIMIT));
    }, TIMEOUT_BUFFER_LIMIT));
  };
  var sessionTimeoutEnd = function sessionTimeoutEnd() {
    if (bufferTimeout && inactiveTimeout) {
      clearTimeout(bufferTimeout);
      clearTimeout(inactiveTimeout);
    }
  };
  var refreshToken = function refreshToken() {
    py.get('current').then(function () {
      sessionTimeoutEnd();
      toggleModal();
      sessionTimeoutStart();
    });
  };
  useEffect(function () {
    if (isAuthed && location.pathname !== '/session-timeout') {
      sessionTimeoutStart();
    }
    return function () {
      return sessionTimeoutEnd();
    };
  }, [isAuthed, location]);
  return React.createElement(SessionTimeoutContext.Provider, {
    value: {
      setIsOpen: setIsOpen
    }
  }, children, React.createElement(Modal, {
    isOpen: isOpen,
    toggle: toggleModal
  }, React.createElement(ModalHeader, {
    toggle: toggleModal
  }, 'Session Inactivity'), React.createElement(ModalBody, null, React.createElement('p', null, 'Your session will expire in ', TIMEOUT_INACTIVE_LIMIT / 60 / 1000, ' minutes.', ' ', 'Inactivity will potentially result in loss of work.'), React.createElement('p', null, 'Are you still active?')), React.createElement(ModalFooter, null, React.createElement(Button, {
    color: 'primary',
    icon: 'check',
    onClick: refreshToken
  }, 'Yes, I am still active'))));
};
SessionTimeoutProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export default SessionTimeoutProvider;
export { SessionTimeoutContext };